<template>
  <div class="o-page__content u-pt-small">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-12">
          <h1 class="u-h3">Profile</h1>
        </div>
      </div>
      <div class="row u-mt-medium">
        <div class="col-6">
          <div class="c-card u-p-medium" v-loading="loading.profile">
            <form @submit.prevent="updateProfile">
              <div class="row">
                <div class="col-lg-12">
                  <div class="c-field u-mb-small">
                    <img :src="profile.avatar" alt="" />
                    <label class="c-field__label" for="firstName">Photo</label>
                    <el-upload
                      class="upload-demo"
                      ref="upload"
                      action=""
                      :on-change="avatarPathFile"
                      :auto-upload="false"
                      :multiple="false"
                      :limit="1"
                    >
                      <el-button slot="trigger" size="small" type="primary"
                        >select file</el-button
                      >
                    </el-upload>
                  </div>
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="email">NPP</label>
                    <input
                      class="c-input"
                      type="text"
                      id="npp"
                      disabled
                      v-model="profile.npp"
                    />
                  </div>
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="firstName1">Role</label>
                    <input
                      class="c-input"
                      disabled
                      type="text"
                      id="firstName1"
                      name="name"
                      v-model="profile.role_name"
                    />
                  </div>
                  <div class="c-field u-mb-small" v-if="profile.role_id == 2">
                    <label class="c-field__label" for="firstName2">Kode Wilayah</label>
                    <input
                      class="c-input"
                      type="text"
                      disabled
                      id="firstName2"
                      name="name"
                      v-model="profile.relation_code"
                    />
                  </div>
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="firstName">Full Name</label>
                    <input
                      class="c-input"
                      type="text"
                      id="firstName"
                      name="name"
                      v-model="profile.name"
                    />
                  </div>
                </div>
              </div>
              <div class="row u-mt-small">
                <div class="col-lg-12 u-text-left">
                  <button class="c-btn c-btn--success" type="submit">Save</button>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="col-6">
          <div class="c-card u-p-medium" v-loading="loading.password">
            <form @submit.prevent="changePassword">
              <div class="row">
                <div class="col-lg-12">
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="firstName">Old password</label>
                    <input class="c-input" type="password" v-model="password.old" />
                  </div>
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="email">New password</label>
                    <input class="c-input" type="password" v-model="password.new" />
                  </div>
                  <div class="c-field u-mb-small">
                    <label class="c-field__label" for="email">Re-type new password</label>
                    <input class="c-input" type="password" v-model="password.renew" />
                  </div>
                </div>
              </div>
              <div class="row u-mt-small">
                <div class="col-lg-12 u-text-left">
                  <button class="c-btn c-btn--success" type="submit">
                    Update Password
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "@/api/admin";

const baseURL = "https://api.squsp-datacenter.com";

export default {
  name: "profile",
  data() {
    return {
      loading: {
        profile: false,
        password: false,
      },
      profile: {
        avatar: baseURL,
        change_avatar: "",
        change_avatar_base64: "",
        name: "",
        username: "",
        role_id: "",
        role_name: "",
        relation_code: "",
      },
      formErrorText: "",
      password: {
        old: null,
        new: null,
        renew: null,
      },
    };
  },
  mounted() {
    this.fetch();
  },
  methods: {
    ...mapActions(["logout"]),
    fetch() {
      var self = this;
      api
        .get()
        .then(function (response) {
          console.log(response);
          self.profile.avatar += response.data.data.avatar;
          self.profile.name = response.data.data.name;
          self.profile.npp = response.data.data.npp;
          self.profile.relation_code = response.data.data.relation_code;
          self.profile.role_id = response.data.data.user_role_id;
          self.profile.role_name =
            response.data.data.user_role_id == 1 ? "Admin" : "Admin Wilayah";
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    avatarPathFile(file) {
      let url = "";
      if (window.createObjectURL != undefined) {
        url = window.createObjectURL(file.raw);
      } else if (window.URL != undefined) {
        url = window.URL.createObjectURL(file.raw);
      } else if (window.webkitURL != undefined) {
        url = window.webkitURL.createObjectURL(file.raw);
      }
      this.profile.avatar = url;

      this.profile.change_avatar = file;
      if (this.profile.change_avatar.raw != undefined) {
        this.createBase64Image(this.profile.change_avatar.raw);
      }
    },
    createBase64Image(fileObject) {
      var reader = new FileReader();
      reader.readAsDataURL(fileObject);
      let baseFile = "";
      reader.onload = () => {
        // <------ use arrow function
        baseFile = reader.result;
        this.profile.change_avatar_base64 = baseFile;
      };
    },
    updateProfile() {
      var self = this;
      const formData = new FormData();
      if (this.profile.change_avatar.raw != undefined) {
        formData.append("avatar", this.profile.change_avatar.raw);
      }
      formData.append("name", this.profile.name);
      api
        .profile(formData)
        .then(function (response) {
          // console.log(response)
          self.$message({
            type: "success",
            message: response.data.message,
          });
          localStorage.setItem("name", response.data.data.name);
          localStorage.setItem("avatar", response.data.data.avatar);
          location.reload();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.status == 403) {
            self.logout();
          }
        });
    },
    changePassword() {
      if (this.password.renew != this.password.new) {
        this.$message({
          type: "error",
          message: "Re-type new password is not equal with new password",
        });
      } else {
        var self = this;
        api
          .password({ old_password: this.password.old, new_password: this.password.new })
          .then(function (response) {
            self.$message({
              type: "success",
              message: response.data.message,
            });
            self.password.old = "";
            self.password.new = "";
            self.password.renew = "";
            self.fetch();
          })
          .catch(function (error) {
            console.log(error);
            self.$message({
              type: "error",
              message: error.response.data.message,
            });
            if (error.response.status == 403) {
              self.logout();
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
